import React, {useEffect, useMemo, useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import {store} from "react-notifications-component";
import client from "../../lib/api/client";
import {styled} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {userState} from "../../state/globalState";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center" style={{color: 'white', margin: '20px 0'}}>
            {'Copyright © '}
            <Link color="inherit" href="https://material-ui.com/">
                EY
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
            height: '100%',
        },
    },
    container: {
        marginTop: '40px',
        width: '100%',
        height: '100%',
        animation: `$smoothAppear 2000ms ${theme.transitions.easing.easeInOut}`
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    "@keyframes smoothAppear": {
        "from": {
            opacity: 0,
            transform: "translateY(30%)"
        },
        "to": {
            opacity: 1,
            transform: "translateY(0)"
        }
    }
}));

const PasswordChangeForm = ({ stdYear, history }) => {
    const userInfo = useRecoilValue(userState);
    const [errorMessage, setErrorMessage] = useState("");
    const [currentPassword, setCurrentPassword] = useState("");
    const [errorMsgCurrentPassword, setErrorMsgCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [errorMsgNewPassword, setErrorMsgNewPassword] = useState("");
    const [newRePassword, setNewRePassword] = useState("");
    const [errorMsgNewRePassword, setErrorMsgNewRePassword] = useState("");
    const classes = useStyles();

    useEffect(() => {
        console.log("Userinfo set!!!1", userInfo);
    }, [userInfo.admnNo]);

    useEffect(() => {
        if (errorMessage) {
            store.addNotification({
                title: "알림",
                message: errorMessage,
                type: 'warning',
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "flipInY"],
                animationOut: ["animated", "flipOutY"],
                dismiss: {
                    duration: 3000,
                    onScreen: false
                },
                width: 500
            });
            setErrorMessage("");
        }
    }, [errorMessage])

    const onChange = e => {
        const { value, name } = e.target;

        if (value.length <= 20) {
            if (name === "currentPassword") {
                setCurrentPassword(value);
                setErrorMsgCurrentPassword("");
            } else if (name === "newPassword") {
                setNewPassword(value);
                setErrorMsgNewPassword("");
                setErrorMsgNewRePassword("");
            } else if (name === "newRePassword") {
                setNewRePassword(value);
                setErrorMsgNewPassword("");
                setErrorMsgNewRePassword("");
            }
        }
    };

    const onSubmit = e => {
        e.preventDefault();
        const passwordRule = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?^&#])[A-Za-z\d@$!%*?^&#]{10,}$$/;

        // 필수 입력값 체크
        if (currentPassword === "") {
            setErrorMsgCurrentPassword("현재 비밀번호를 입력하세요.");
        }

        if (newPassword === "") {
            setErrorMsgNewPassword("새 비밀번호를 입력하세요.");
        }

        if (newRePassword === "") {
            setErrorMsgNewRePassword("새 비밀번호를 입력하세요.");
        }

        if (currentPassword === "" || newPassword === "" || newRePassword === "") {
            return false;
        }

        if (newPassword !== newRePassword) {
            setErrorMsgNewPassword("새 비밀번호가 일치하지 않습니다.");
            setErrorMsgNewRePassword("새 비밀번호가 일치하지 않습니다.");
            return false;
        }

        if (currentPassword === newPassword) {
            setErrorMsgNewPassword("현재 비밀번호와 같습니다.");
            setErrorMsgNewRePassword("현재 비밀번호와 같습니다.");
            return false;
        }

        if (!passwordRule.test(newPassword)) {
            setErrorMsgNewPassword("최소 10 자, 대문자, 소문자, 숫자, 특수 문자가 포함되어야 합니다. (허용 특수문자: @$!%*?^&#)");
            setErrorMsgNewRePassword("최소 10 자, 대문자, 소문자, 숫자, 특수 문자가 포함되어야 합니다. (허용 특수문자: @$!%*?^&#)");
            return false;
        }

        if (!userInfo.admnNo) {
            console.log("not found");
            return;
        }

        client.post('/kognr/changePassword', {
            admnNo: userInfo.admnNo,
            currentPassword,
            newPassword
        }).then(response => {
            const { success } = response.data;
            if (success) {
                history.push('/agree');
            } else {
                const { error } = response.data;
                store.addNotification({
                    title: "알림",
                    message: error.message,
                    type: 'warning',
                    insert: "top",
                    container: "top-center",
                    animationIn: ["animated", "flipInY"],
                    animationOut: ["animated", "flipOutY"],
                    dismiss: {
                        duration: 3000,
                        onScreen: false
                    },
                    width: 500
                });
            }
        }).catch((error) => {
            const {status, data} = error.response;
            if (status === 403) {
                setErrorMessage(data.message);
            }
        });
    };

    const PasswordTextField = useMemo(() => {
        return styled(TextField)({
            '& label.MuiInputLabel-root': {
                color: 'white',
            },
            '& label.Mui-focused': {
                color: 'white',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'white',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'white',
                },
                '&:hover fieldset': {
                    borderColor: 'yellow',
                },
                '&.Mui-focused fieldset': {
                    borderColor: 'white',
                },
            },
            '& input': {
                color: 'white',
            },
        });
    }, []);

    console.log("USER : ", userInfo);
    return (
        <>
            {userInfo && (
                <div>
                    <CssBaseline />
                    <Container component="main" maxWidth="xs" className={classes.container}>
                        <div className={classes.paper}>
                            <Avatar className={classes.avatar}>
                                <LockOutlinedIcon />
                            </Avatar>
                            <Typography component="h1" variant="h5" style={{color: 'white'}}>
                                비밀번호 변경
                            </Typography>
                            <Typography variant="subtitle2" gutterBottom component="div" style={{color: 'white'}}>
                                최소 10 자, 대문자, 소문자, 숫자, 특수 문자가 포함되어야 합니다.
                            </Typography>
                            <Typography variant="subtitle2" gutterBottom component="div" style={{color: 'white'}}>
                                (허용 특수문자: @$!%*?^&#)
                            </Typography>
                            <form className={classes.form} noValidate onSubmit={onSubmit}>
                                <PasswordTextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    size="small"
                                    name="currentPassword"
                                    label="현재 비밀번호"
                                    type="password"
                                    autoComplete="off"
                                    error={errorMsgCurrentPassword !== ""}
                                    helperText={errorMsgCurrentPassword}
                                    onChange={onChange}
                                    value={currentPassword}
                                />
                                <PasswordTextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    size="small"
                                    name="newPassword"
                                    label="새 비밀번호"
                                    type="password"
                                    autoComplete="off"
                                    error={errorMsgNewPassword !== ""}
                                    helperText={errorMsgNewPassword}
                                    onChange={onChange}
                                    value={newPassword}
                                />
                                <PasswordTextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    size="small"
                                    name="newRePassword"
                                    label="새 비밀번호 재입력"
                                    type="password"
                                    autoComplete="off"
                                    error={errorMsgNewRePassword !== ""}
                                    helperText={errorMsgNewRePassword}
                                    onChange={onChange}
                                    value={newRePassword}
                                />
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                >
                                    비밀번호 변경
                                </Button>
                            </form>
                            <Box>
                                <Copyright />
                            </Box>
                        </div>
                    </Container>
                </div>
            )}
        </>
    );
};

export default withRouter(PasswordChangeForm);

